import { render } from "./CheckoutSummaryDetailed.vue?vue&type=template&id=48aad55b"
import script from "./CheckoutSummaryDetailed.vue?vue&type=script&lang=js"
export * from "./CheckoutSummaryDetailed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__